import React from 'react';
import { SummaryType } from '../../../../common/commonTypes';
import MacroBar from './MacroBar';
import { useTranslation } from 'react-i18next';

type MacrosChartType = {
    weeklyAverages: SummaryType;
    dailySummary: SummaryType;
};

const findLargestMacroValue = (weeklyAverages: SummaryType, dailySummary: SummaryType) => {
    const macros = ['protein', 'fats', 'carbsNoSugars', 'sugars'];
    const values = macros.flatMap((macro) => [
        // @ts-ignore
        weeklyAverages[macro],
        // @ts-ignore
        dailySummary[macro],
    ]);
    return Math.max(...values);
};

const MacrosChart = (props: MacrosChartType) => {
    const { weeklyAverages, dailySummary } = props;

    const { t, i18n } = useTranslation();

    const macrosMax = findLargestMacroValue(weeklyAverages, dailySummary);
    const caloriesMax = Math.max(weeklyAverages.calories, dailySummary.calories);

    return (
        <>
            <table className="text-md w-full mb-2">
                <tbody>
                    <tr>
                        <td className="w-20">{t('calories')}:</td>
                        <td className="w-10">{dailySummary.calories}</td>
                        <td className="w-auto">
                            <MacroBar
                                type={'CALORIES'}
                                daily={dailySummary.calories}
                                weekly={weeklyAverages.calories}
                                max={caloriesMax}
                            />
                        </td>
                        <td className="w-10 text-right">{weeklyAverages.calories}</td>
                    </tr>
                </tbody>
            </table>

            <table className="text-sm w-full">
                <tbody>
                    <tr>
                        <td className="w-20">{t('protein_gr')}:</td>
                        <td className="w-10">{dailySummary.protein}</td>
                        <td className="w-auto">
                            <MacroBar
                                type={'PROTEIN'}
                                daily={dailySummary.protein}
                                weekly={weeklyAverages.protein}
                                max={macrosMax}
                            />
                        </td>
                        <td className="w-10 text-right">{weeklyAverages.protein}</td>
                    </tr>
                    <tr>
                        <td className="w-20">{t('fat_gr')}:</td>
                        <td className="w-10">{dailySummary.fats}</td>
                        <td className="w-auto">
                            <MacroBar
                                type={'FAT'}
                                daily={dailySummary.fats}
                                weekly={weeklyAverages.fats}
                                max={macrosMax}
                            />
                        </td>
                        <td className="w-10 text-right">{weeklyAverages.fats}</td>
                    </tr>
                    <tr>
                        <td className="w-20">{t('carbs_gr')}:</td>
                        <td className="w-10">{dailySummary.carbsNoSugars}</td>
                        <td className="w-auto">
                            <MacroBar
                                type={'CARBS'}
                                daily={dailySummary.carbsNoSugars}
                                weekly={weeklyAverages.carbsNoSugars}
                                max={macrosMax}
                            />
                        </td>
                        <td className="w-10 text-right">{weeklyAverages.carbsNoSugars}</td>
                    </tr>
                    <tr>
                        <td className="w-20">{t('sugar_gr')}:</td>
                        <td className="w-10">{dailySummary.sugars}</td>
                        <td className="w-auto">
                            <MacroBar
                                type={'SUGARS'}
                                daily={dailySummary.sugars}
                                weekly={weeklyAverages.sugars}
                                max={macrosMax}
                            />
                        </td>
                        <td className="w-10 text-right">{weeklyAverages.sugars}</td>
                    </tr>
                </tbody>
            </table>
        </>
    );
};

export default MacrosChart;
